import { render, staticRenderFns } from "./SupplierReturnFormView.vue?vue&type=template&id=1f44572c&"
import script from "./SupplierReturnFormView.vue?vue&type=script&lang=ts&"
export * from "./SupplierReturnFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f44572c')) {
      api.createRecord('1f44572c', component.options)
    } else {
      api.reload('1f44572c', component.options)
    }
    module.hot.accept("./SupplierReturnFormView.vue?vue&type=template&id=1f44572c&", function () {
      api.rerender('1f44572c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/supplier-return/SupplierReturnFormView.vue"
export default component.exports